import React from 'react';
import './MangaList.css';  // Import custom styling

const MangaList = ({ mangaItems }) => {
  return (
    <div className="manga-list">
      <h1 className="manga-list-title">Manga List</h1>
      <div className="manga-list-items">
        {mangaItems.length === 0 ? (
          <p>No manga found.</p>  // Show message if no manga items are found
        ) : (
          mangaItems.map((manga) => (
            <div className="manga-list-item" key={manga.id}>
              <img
                src={manga.attributes.posterImage.small}
                alt={manga.attributes.canonicalTitle}
                className="manga-list-image"
              />
              <h3>{manga.attributes.canonicalTitle}</h3>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default MangaList;
